export const SET_AUTHENTICATED = "SET_AUTHENTICATED"
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED"
export const SET_USER = "SET_USER"
export const LOADING_USER = "LOADING_USER"

export const SET_ERRORS = "SET_ERRORS"
export const LOADING_UI = "LOADING_UI"
export const CLEAR_ERRORS = "CLEAR_ERRORS"
export const STOP_LOADING_UI = "STOP_LOADING_UI"

export const SET_CHAT_TIMESTAMP = "SET_CHAT_TIMESTAMP"
export const SEND_GRATITUDE_ENTRY = "SEND_GRATITUDE_ENTRY"
export const GET_GRATITUDE_ENTRIES = "GET_GRATITUDE_ENTRIES"
export const LOADING_DATA = "LOADING_DATA"
export const GET_MOOD_RECORDS = "GET_MOOD_RECORDS"